<template>
    <div class="filters">
        <div class="card">
            <div class="card-header">
                <h3 class="card-title">Liste des tailles</h3>
            </div>
            <el-form ref="filtersForm" :model="filters" label-position="top">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <el-form-item prop="search" label="Rechercher">
                                <el-input clearable v-model="filters.search" placeholder="Rechercher" />
                            </el-form-item>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="pull-right">
                        <el-button @click="resetFilters" type="info" plain>Annuler</el-button>
                        <el-button @click="validFilters" type="primary">Valider</el-button>
                    </div>
                </div>
            </el-form>
        </div>

    </div>
</template>
<script>
import { EventBus } from '../../event-bus';
import Feature from '../../models/Feature';

export default {
    data() {
        return {
            brandsOptions: [],
            categoriesOptions: [],
            manufacturersOptions: [],
            filters: {
                search: '',
            },
            groupedActionsOptions: [

            ],
            groupedActionsValue: '',
            modal: {
                activate_desactivate: {
                    display: false,
                    loader: false,
                    form: {
                        activated: false
                    }
                },
                activate_desactivate_vehiculier: {
                    display: false,
                    loader: false,
                    form: {
                        activated: false
                    }
                }
            }
        };
    },
    props: {
        selected: {
            default() {
                return [];
            }
        }
    },
    computed: {
        q: {
            get() {
                return this.$store.getters['app/q'];
            },
            set(value) {
                this.$store.dispatch('app/setQ', value);
            }
        },
        total_item() {
            return this.$store.getters['variationValues/totalItems'];
        },
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        },
        applyToAllResult: {
            get() {
                return this.$store.getters['variationValues/applyToAllResults'];
            },
            set(value) {
                this.$store.dispatch('variationValues/setApplyToAllResults', value);
            }
        }
    },
    mounted() {
        EventBus.$on('search-input.submit', () => {
            this.validFilters();
        });
    },
    methods: {
        resetFilters() {
            this.$refs.filtersForm.resetFields();
            this.$store.dispatch('app/setQ', null);
            this.validFilters();
        },

        validFilters() {
            var filters = {};
            this.filters.q = this.q;
            var exclude = ['applyToAllResult'];
            for (let filter in this.filters) {
                if (
                    this.filters[filter] != '' &&
                    this.filters[filter] !== null &&
                    exclude.indexOf(filter) == -1
                ) {
                    filters[filter] = this.filters[filter];
                }
            }
            this.$emit('update-filters', filters);
        },
        setFilter(filter_name, value, noValidate) {
            this.filters[filter_name] = value;
            if (!noValidate) {
                this.validFilters();
            }
        },


    }
};
</script>
<style lang="scss">
.el-form {
    .card-footer {
        text-align: initial;
        .pull-right {
            text-align: center;
        }
    }
}
</style>
